import React from "react";
import styles from "./NewsletterModal.module.scss";
import IconValidateCheck from "../icons/IconValidateCheck";
import IconAlertTriangle from "../icons/IconAlertTriangle";
import IconGlobeUnregister from "../icons/IconGlobeUnregister";
import { registerEmail } from "../../../api";
import { toast } from "react-toastify";
import _ from "../../../i18n";
import { useSelector } from "react-redux";
import Loader from "../Loader";

const CollaboratorBlock = ({
  sender,
  removeClick,
  verifiedEmailsList,
  handleFetchVerifiedEmails,
  domains,
  handleVerifyDomain,
  setSlide,
  setSelectedDomain,
  isVerifying,
  setIsVerifying,
}) => {
  const auth = useSelector((state) => state.auth);
  const { token } = auth;
  const verifiedEmail = verifiedEmailsList.find(
    (emailObj) =>
      emailObj.email === sender.email &&
      emailObj.VerificationStatus === "Success"
  );
  const isPendingEmail = verifiedEmailsList.find(
    (emailObj) =>
      emailObj.email === sender.email &&
      emailObj.VerificationStatus === "Pending"
  );
  const domain = sender.email.split("@")[1];
  const domainInfo = domains[domain];
  const isDomainPending = domainInfo?.status === "PENDING";
  const isDomainUnregistered = domainInfo?.status === "UNREGISTERED";
  const handleRegisterEmail = () => {
    registerEmail(token, sender.email)
      .then(() => {
        handleFetchVerifiedEmails();
      })
      .catch(() => {
        toast.error(_("error"));
      });
  };
  const handleVerifyDomainClick = async (email) => {
    try {
      setIsVerifying(true);

      await handleVerifyDomain(email);

      const domain = email.split("@")[1];
      setSelectedDomain(domain);

      setSlide(3);
    } catch (e) {
      console.error(e);
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className={styles.collab_block}>
      <div className={styles.block_name}>
        <span className={styles.name}>{sender.label}</span>
        <i className="icon-ttp-trash" onClick={() => removeClick(sender)} />
      </div>

      <div className={styles.block_email}>
        <span className={styles.email}>{sender.email}</span>
        {verifiedEmail ? <IconValidateCheck /> : <IconAlertTriangle />}
      </div>

      {!verifiedEmail && (
        <>
          <span className={styles.warning}> {_("email_not_confirmed")}</span>
          {isPendingEmail ? (
            <>
              <button className={styles.load_btn}>
                <Loader style={{ height: "10px" }} color={"#06d9b1"} />
              </button>
              <span
                className={styles.refresh}
                onClick={() => handleFetchVerifiedEmails()}
              >
                {_("refresh")}
              </span>
            </>
          ) : (
            <button
              className={styles.confirm_btn}
              onClick={() => handleRegisterEmail()}
            >
              {_("send_confirmation")}
            </button>
          )}
        </>
      )}

      {isPendingEmail && (
        <div className={styles.info}>
          <p className={styles.info_text}>
            Un email a été envoyé par Amazon à l'adresse email. Répondez-y et
            cliquez sur Rafraîchir.
          </p>
        </div>
      )}
      {isDomainUnregistered && (
        <div className={styles.info}>
          <p className={styles.info_text}>
            Le domaine de cette adresse mail n'est pas enregistré dans SES.
          </p>
          <div className={styles.info_footer}>
            <span
              className={styles.domain_link}
              onClick={() => handleVerifyDomainClick(sender.email)}
            >
              {isVerifying ? (
                <Loader style={{ height: "10px", marginLeft: "60px" }} color={"#EA8124"} />
              ) : (
                _("Enregistrer le domaine")
              )}
            </span>
            <IconGlobeUnregister />
          </div>
        </div>
      )}

      {isDomainPending && (
        <div className={styles.info}>
          <p className={styles.info_text}>{_("domain_pending_dns")}</p>
          <span
            className={styles.read_more}
            onClick={() => {
              const domain = sender.email.split("@")[1];
              setSelectedDomain(domain);
              setSlide(3);
            }}
          >
            <strong>{_("Read_more")}</strong>
          </span>
        </div>
      )}
    </div>
  );
};

export default CollaboratorBlock;
